import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-simulation',
  templateUrl: './simulation.component.html',
  styleUrls: ['./simulation.component.css'],
})
export class SimulationComponent implements OnInit {

  public tableMetaData: Array<any>;
  public filteredTableMetaData: Array<any>;
  public tableData: Array<any>;


  constructor() {
  }

  ngOnInit() {
    this.filterTableMetaData();
  }

  public filterTableMetaData() {
    this.filteredTableMetaData = this.tableMetaData.filter((x) => x.enabled);
  }

}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/simulation/simulation.component.ts